import React from "react";
import { Snackbar, Alert } from "@mui/material";

const ToastAlert = ({ open, onClose, message, severity = "info" }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000} // 5 seconds
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert onClose={onClose} severity={severity} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ToastAlert;
